/**
 * This file is auto-generated from ComboboxInput.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */

import type { Translation } from '@nzyme/i18n-core';

export const noResults: Translation = lang => {
    switch (lang) {
        case 'en':
            return 'No results found';
        case 'pl':
            return 'Brak wyników';
    }
};
